import { Div, Span } from "@tblabs/truffle";
import { Rows } from "../../../Components/Utils/Rows";
import { AgentsProvider } from "../../../Services/Agents/AgentsProvider";
import { TimeUtils } from "../../../Utils/TimeUtils";
import { PersonalPickupStepData } from "../Models/PersonalPickupStepData";
import { InfoFrame } from "../../../Components/Utils/InfoFrame";


export class MeetingInfoForCustomer extends Rows
{
    constructor(_agent: AgentsProvider, data: PersonalPickupStepData)
    {
        const agent = _agent.Get(data.AssignedAgentId.value);

        const sum = (data.BasketSum.value + data.DepositSum.value) || data.PaymentAtDelivery.value; // <--- PaymentAtDelivery is legacy
        const deposit = data.DepositSum.value;

        super([
            new Span(`🕓 Pora spotkania: ${TimeUtils.FormattedDayHour(data.PlannedDispatchTime)}`)
                .When(data.PlannedDispatchTime, v => TimeUtils.IsHourSet(v), _ => _.Background("none"), _ => _.Background("#ffe5e5")),
            new Span(`🗺️ Miejsce odbioru: ${data.MeetingPlace.value || "jeszcze nie ustalone"}`),
            new Span(`👤 ${agent
                ? `Spotkanie z: ${agent.Name}, tel. ${agent.Phone}`
                : "Opiekun jeszcze nie przypisany"}`)
                .When(data.AssignedAgentId, v => !!v, _ => _.Background("none"), _ => _.Background("#ffe5e5")),
            new Span(sum > 0
                ? `💰 Płatność łącznie: ${sum} zł (w tym ${deposit} zł zwrotnej kaucji), płatne tylko gotówką`
                : `💰 Zamówienie jest już opłacone`),
            new Span(data.Training.value
                ? `🎓 Szkolenie odbędzie się na miejscu`
                : `🎓 Bez szkolenia`),
            // !data.AssignedAgentId
            // && !data.MeetingPlace.value
            // && new InfoFrame("Co teraz?", "Czas, miejsce i osoba z którą się spotkasz nie zostały jeszcze ustalone."),
        ]);
    }
}
